import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import useSWRV from "swrv";
import { getData } from "@/services/axios";
import { cdate } from "@/utils/cdate";

import { inject, ref, watch } from 'vue';
import { isAuthenticatedKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default {
  __name: 'ForumMailIndex',
  setup: function setup(__props) {
    // @ts-check
    var isAuthenticated = inject(isAuthenticatedKey);
    var currentFiscalYear = cdate().add(-3, "month").get("year");
    var threeYearsAgo = cdate().add(-3, "month").add(-3, "year").get("year");
    var fiscalYears = [];
    var i;
    for (i = threeYearsAgo; i <= currentFiscalYear; i++) {
      if (i === currentFiscalYear) {
        fiscalYears.push({
          value: currentFiscalYear,
          label: "今年度"
        });
      } else {
        fiscalYears.push({
          value: i,
          label: i + "年度"
        });
      }
    }
    var payload = ref({
      target: null,
      use_email: true
    });
    var filter = ref({
      title: "",
      date: "",
      fiscalYear: currentFiscalYear
    });
    var resetFilter = function resetFilter() {
      filter.value = {
        title: "",
        date: "",
        fiscalYear: currentFiscalYear
      };
      handleFilter();
    };
    var _useSWRV = useSWRV(function () {
        return isAuthenticated.value && "forum";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("government_forum", payload.value);
            case 1:
              result = _context.v;
              result.items.last_fetched_at = cdate().format("YYYY年MM月DD日 HH時mm分");
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        refreshInterval: 60000,
        revalidateOnFocus: false
      }),
      forumList = _useSWRV.data,
      mutate = _useSWRV.mutate;
    var filteredForumList = ref([]);
    var handleFilter = function handleFilter() {
      console.log(filter.value);
      var f = Array.isArray(forumList.value) && forumList.value.slice();
      if (filter.value.title) {
        f = Array.isArray(f) && f.filter(function (v) {
          return v.title.includes(filter.value.title);
        });
      }
      if (filter.value.date) {
        f = Array.isArray(f) && f.filter(function (v) {
          return v.created_at.startsWith(filter.value.date);
        });
      }
      if (filter.value.fiscalYear) {
        f = Array.isArray(f) && f.filter(function (v) {
          return cdate(v.created_at) >= cdate("".concat(filter.value.fiscalYear, "-04-01")) && cdate(v.created_at) < cdate("".concat(filter.value.fiscalYear + 1, "-04-01"));
        });
      }
      filteredForumList.value = f;
    };
    watch(function () {
      return forumList.value;
    }, function () {
      handleFilter();
    });
    var emailStatus = function emailStatus(status) {
      switch (status) {
        case "sent":
          return "送信完了";
        case "pending":
          return "送信待ち";
        case "sending":
          return "送信中";
        case "not_sent":
          return "メール送信なし";
        case "failed":
          return "送信失敗";
        default:
          return "不明";
      }
    };
    watch(function () {
      return payload.value.target;
    }, function () {
      mutate();
    });
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      currentFiscalYear: currentFiscalYear,
      threeYearsAgo: threeYearsAgo,
      fiscalYears: fiscalYears,
      i: i,
      payload: payload,
      filter: filter,
      resetFilter: resetFilter,
      forumList: forumList,
      mutate: mutate,
      filteredForumList: filteredForumList,
      handleFilter: handleFilter,
      emailStatus: emailStatus,
      cdate: cdate
    };
  }
};